export default __webpack_public_path__ + "static/media/web.532a6648.svg";